var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjectPulpWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 86.587,
    height: 73.422,
    viewBox: "0 0 86.587 73.422",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_395",
    "data-name": "Rectangle 395",
    width: 86.587,
    height: 73.422,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1777",
    "data-name": "Group 1777",
    transform: "translate(1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1183",
    "data-name": "Group 1183",
    transform: "translate(-1)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_656",
    "data-name": "Path 656",
    d: "M0,138.438v-1.86a3.114,3.114,0,0,1,1.956-1.68,44.562,44.562,0,0,1,6.758-.015c2.952.355,2.892,4.9,0,5.25a44.562,44.562,0,0,1-6.758-.015A3.114,3.114,0,0,1,0,138.438",
    transform: "translate(0 -111.972)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_657",
    "data-name": "Path 657",
    d: "M458.423,136.578v1.86a3.114,3.114,0,0,1-1.956,1.68,44.562,44.562,0,0,1-6.758.015c-2.892-.348-2.952-4.9,0-5.25a44.562,44.562,0,0,1,6.758.015,3.114,3.114,0,0,1,1.956,1.68",
    transform: "translate(-371.836 -111.972)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_658",
    "data-name": "Path 658",
    d: "M131.675,59.106H117.468a12.013,12.013,0,0,0-4.749-9.541c-4.284-3.257-7.045-4.437-10.136-9.312C89.912,20.267,108.2-4.846,131.033.81c19.96,4.945,26.417,30.648,11.215,44.6-3.037,2.787-6.729,3.946-8.912,7.661a11.152,11.152,0,0,0-1.661,6.033M112.52,12.47a2.409,2.409,0,0,0-1.548.988c-2.035,3.519-5.555,6.979-7.442,10.485a2.559,2.559,0,0,0-.174,2.852c2.737,3.166,4.951,7.7,7.69,10.744a2.534,2.534,0,0,0,4.027-.025c1.111-1.561.348-2.493-.51-3.83-1.781-2.778-4.078-5.38-5.861-8.179,1.736-2.873,4.059-5.478,5.861-8.288a5.857,5.857,0,0,0,.97-1.734,2.518,2.518,0,0,0-3.013-3.013m15.05,0a2.549,2.549,0,0,0-1.819,1.563l-7.19,21.219a2.55,2.55,0,0,0,4.782,1.739l7.24-21.339a2.538,2.538,0,0,0-3.012-3.182m7.948,0a2.533,2.533,0,0,0-1.778,3.392l6.7,9.536c-2.094,3.457-4.889,6.492-6.833,10.023a2.537,2.537,0,0,0,4.487,2.118c2.75-2.9,4.976-7.658,7.691-10.743a2.489,2.489,0,0,0,0-2.687c-1.832-3.523-5.691-7.172-7.689-10.744a2.618,2.618,0,0,0-2.579-.894",
    transform: "translate(-81.785 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_659",
    "data-name": "Path 659",
    d: "M225.206,379.5v7.526c0,.921-1.114,1.535-1.936,1.615-3.353.325-7.24-.251-10.652-.019a2.081,2.081,0,0,1-1.617-1.6V379.5Z",
    transform: "translate(-175.317 -315.321)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_660",
    "data-name": "Path 660",
    d: "M24.677,6.874a3.007,3.007,0,0,1,1.9.712,53.907,53.907,0,0,1,5.764,4.891,2.7,2.7,0,0,1-3.332,4.177,40.409,40.409,0,0,1-4.45-3.668c-1.441-1.278-3.257-2.372-2.224-4.6a2.643,2.643,0,0,1,2.339-1.514",
    transform: "translate(-18.308 -5.711)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_661",
    "data-name": "Path 661",
    d: "M432.991,6.874a2.624,2.624,0,0,1,2.394,1.405c1.178,2.251-.7,3.409-2.164,4.707a40.379,40.379,0,0,1-4.45,3.668,2.7,2.7,0,0,1-3.332-4.177A53.922,53.922,0,0,1,431.2,7.586a3.036,3.036,0,0,1,1.789-.712",
    transform: "translate(-352.888 -5.711)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_662",
    "data-name": "Path 662",
    d: "M426.919,235.384a2.791,2.791,0,0,1,2.231.394,59.439,59.439,0,0,1,6.27,5.4,2.71,2.71,0,0,1-3.336,4.013l-6.4-5.274c-1.394-1.408-.837-4.176,1.23-4.531",
    transform: "translate(-353.06 -195.516)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_663",
    "data-name": "Path 663",
    d: "M29.467,235.357a2.693,2.693,0,0,1,2.894,4.245l-6.615,5.561a2.72,2.72,0,0,1-3.411-3.919c.609-.933,4.319-3.9,5.408-4.739a5.842,5.842,0,0,1,1.725-1.149",
    transform: "translate(-18.183 -195.491)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectPulpWhite);
export default __webpack_public_path__ + "static/media/project-pulp-white.d096f8cbccdf841a644699ce5367de52.svg";
export { ForwardRef as ReactComponent };